import Vue from 'vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/pt-br';
Vue.use(DatePicker);
